'use strict';

exports.__esModule = true;
var QUERY_SEPARATOR = exports.QUERY_SEPARATOR = '?';
var QUERY_PARAM_SEPARATOR = exports.QUERY_PARAM_SEPARATOR = '&';
var LANG_QUERY_PARAM = exports.LANG_QUERY_PARAM = 'lang=';
var QUERY_WHITELIST = exports.QUERY_WHITELIST = [LANG_QUERY_PARAM, 'lightbox='];
var PATTERN_PREFIX = exports.PATTERN_PREFIX = '{{';
var SELF_REF_PATTERN_PREFIX = exports.SELF_REF_PATTERN_PREFIX = '{{@';
var PATTERN_SUFFIX = exports.PATTERN_SUFFIX = '}}';